export const rejectPriceRequestSuccessCms = {
  ok: "Ok",
  successTitle: "Suksess!",
  successSubtitle:
    "Denne forespørselen er nå avvist! Om du skulle ønske å finne den igjen, er den nå plassert under “Avsluttet / Arkivert” i 30 dager.",
};
